import { NextResponse } from 'next/server'
import { query, uuid } from '@/lib/db'

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')
  const cats = await query('SELECT * FROM categories WHERE shop_id = ? ORDER BY name', [shopId])
  return NextResponse.json(cats)
}

export async function POST(req: Request) {
  const { shop_id, name, color } = await req.json()
  const id = uuid()
  await query('INSERT INTO categories (id, shop_id, name, color) VALUES (?, ?, ?, ?)', [id, shop_id, name, color || '#6366f1'])
  return NextResponse.json({ id, shop_id, name, color })
}
